import { FC, memo } from 'react'
import { Button } from '@chakra-ui/react'

import UnifiedPersonCard from 'CitizenProfile/components/CitizenCard'
import { UnifiedPerson } from 'CitizenProfile/types'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { useCustomFormUnifiedPersonSelectionDrawerManager } from '../../../../contexts/CustomFormUnifiedPersonSelectionDrawerManager/Provider'

type Props = {
  unifiedPerson: UnifiedPerson
  onClose: () => void
}

const CustomFormUnifiedPersonCardToSelect: FC<Props> = ({ unifiedPerson, onClose }) => {
  const { questionKey, selectedUnifiedPerson, setSelectedUnifiedPerson, filter } =
    useCustomFormUnifiedPersonSelectionDrawerManager()

  const { formMethods } = useCustomFormViewer()

  function selectUnifiedPerson(selectedUnifiedPerson: UnifiedPerson) {
    formMethods?.setValue(questionKey, [
      selectedUnifiedPerson.id,
      selectedUnifiedPerson.slug,
      selectedUnifiedPerson.name,
    ])
    setSelectedUnifiedPerson(selectedUnifiedPerson)
  }

  function removeUnifiedPerson() {
    formMethods?.setValue(questionKey, undefined)
    setSelectedUnifiedPerson({})
  }

  return (
    <UnifiedPersonCard isDefaultCitizenCard citizen={unifiedPerson} citizenFilter={filter}>
      {selectedUnifiedPerson?.id === unifiedPerson.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeUnifiedPerson()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectUnifiedPerson(unifiedPerson)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )}
    </UnifiedPersonCard>
  )
}

export default memo(CustomFormUnifiedPersonCardToSelect)
